// extracted by mini-css-extract-plugin
export var breadcrumb = "_w-0";
export var breadcrumbArrow = "_w-1";